import { Component, HostListener, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Cart, CartClient, MyAccountClient, User, UserClient, WebinarClient, WebinarRoom, API_BASE_URL } from '../Services/WOWApi.Service';
import { CustomServiceService } from '../Services/custom-service.service';
import { CommonService } from '../Services/common.service';
import { Subscription } from 'rxjs';
import { CommonServices } from '../Common/CommonServices';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.css'],
    standalone: false
})
export class MenuComponent implements OnInit, OnDestroy {
  isLoading: any = {};
  userLoggedIn: boolean = false;
  loggedUser: User;
  webinarRoom: WebinarRoom;
  webinarRooms: WebinarRoom[];
  cartCount:number;
  @Input() isNavBarOpen;
  isMobileView = false;
  /** iPad / tablet portrait: app uses mobile layout but wide viewport — show recommended 3-column header */
  isTabletPortraitHeader = false;
  subscription: Subscription;
  showSpinner: any = {};
  userDetails: User;
  isEmailVerified = true;
  cartRemainingTime = '';
  walletBalance: number = 0;
  isLoadingWallet: boolean = false;

  private readonly http = inject(HttpClient);
  private readonly baseUrl: string = inject(API_BASE_URL, { optional: true }) || '';

  constructor(private webinarClient: WebinarClient,
    private cartClient:CartClient,
    private router: Router, private customServices:CustomServiceService,
    private commonServices: CommonServices,
    private commonService: CommonService,
    private userClient: UserClient,
    private myAccountClient: MyAccountClient,
    private Route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.subscription = this.commonService.cartExpireRemainingTime.subscribe(remainingTime => this.cartRemainingTime = remainingTime);
    this.userDetails = JSON.parse(localStorage.getItem("UserInfo"));
    if (this.userDetails !== null && this.userDetails !== undefined && this.userDetails.isEmailVerified === false) {
      this.isEmailVerified = false;
      if (!this.Route.snapshot.queryParamMap.get('Value1')) {
        this.commonServices.showMessage('X', `Email '${this.userDetails.emailId}' is not verified yet, please verify your email by generating EmailVerification Link.`, 10)
      }
    }
    this.subscription = this.commonService.isMobileView.subscribe(res => {
      this.isMobileView = res;
      if(res === true) {
        this.isNavBarOpen = true;
      } else {
        this.isNavBarOpen = false;
      }
      this.updateTabletHeaderFlag();
    })
    this.loggedUser = this.customServices.GetLoggedInUser();
    this.GetWebinars();
    if(this.loggedUser)
    {
      this.userLoggedIn = true;
      this.commonService.setUserLoggedIn(true);
      // this.showSpinner.cartCount = true;
      // this.cartClient.getCartCount(this.loggedUser.id).subscribe(x => {
      //   this.cartCount = x;
      //   this.showSpinner.cartCount = false;
      // }, error => {
      //   this.showSpinner.cartCount = false;
      // });
      this.showSpinner.cart = true;
      this.cartClient.getCart(this.loggedUser.id).subscribe(data => {
        if (data !== null) {
          this.commonService.setUserCart(data);
        }
        this.showSpinner.cart = false;
      }, error => {
        this.showSpinner.cart = false;
      });
      this.subscription = this.commonService.userCart.subscribe(res => {
        this.cartCount = res.cartDetails !== null ? res.cartDetails.length : 0;
      });
      this.getBillingAddress();
      this.getShippingAddress();
      this.getCommunicationMethod();
      this.loadWalletBalance();
    }
    this.subscription = this.commonService.isUserLoggedIn.subscribe(res => {
      this.userLoggedIn = res;
      if (res && this.loggedUser) {
        this.loadWalletBalance();
      } else {
        this.walletBalance = 0;
      }
    });
    this.updateTabletHeaderFlag();
  }

  @HostListener('window:resize')
  onMenuWindowResize(): void {
    this.updateTabletHeaderFlag();
  }

  private updateTabletHeaderFlag(): void {
    const w = typeof window !== 'undefined' ? window.innerWidth : 0;
    this.isTabletPortraitHeader = this.isMobileView && w >= 768;
  }

  loadWalletBalance(): void {
    if (!this.loggedUser || !this.loggedUser.id) {
      return;
    }

    this.isLoadingWallet = true;
    const apiUrl = `${this.baseUrl}/api/Wallet/GetAvailableBalance/${this.loggedUser.id}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    this.http.get<number>(apiUrl, { headers }).subscribe(
      (balance: number) => {
        this.walletBalance = balance || 0;
        this.isLoadingWallet = false;
      },
      (error) => {
        // If wallet doesn't exist, balance is 0
        this.walletBalance = 0;
        this.isLoadingWallet = false;
      }
    );
  }

  getBillingAddress() {
    this.isLoading.billingAddress = false;
    this.myAccountClient.getBillingAddress(this.loggedUser.id).subscribe(response => {
      if (!!response) {
        this.commonService.setBillingAddress(response);
      }
      this.isLoading.billingAddress = false;
    }, error => {
      this.isLoading.billingAddress = false;
      this.commonServices.showMessage('X', `Error found while getting billing address`);
    });
  }

  getShippingAddress() {
    this.isLoading.shippingAddress = false;
    this.myAccountClient.getShippingAddress(this.loggedUser.id).subscribe(response => {
      if (!!response) {
        this.commonService.setShippingAddress(response);
      }
      this.isLoading.shippingAddress = false;
    }, error => {
      this.isLoading.shippingAddress = false;
      this.commonServices.showMessage('X', `Error found while getting shipping address`);
    });
  }

  getCommunicationMethod() {
    this.isLoading.commMethod = false;
    this.myAccountClient.getCommunicationMethod(this.loggedUser.id).subscribe(response => {
       this.commonService.setCommunicationMethods(response);
       this.isLoading.commMethod = false;
    }, error => {
       this.isLoading.commMethod = false;
    });
  }


  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

 GetWebinars() {
    this.webinarClient.getWebinarRooms(false).subscribe(data => {
      this.webinarRooms = data;
    }, error => { });
  }

  GetCartCount()
  {

  }
  Logout() {
    localStorage.removeItem("UserInfo"); 
    this.commonService.setUserLoggedIn(false);
    this.router.navigateByUrl('/Webinar-rooms');
    this.commonService.setIsPageReload(true);
    this.userLoggedIn = false
  }

  Home() {
    this.router.navigate(["Webinar-rooms"]);
    this.onMenuClick();
  }

 

  OpenWebinar(room: any) {
    this.router.navigate(["Webinars", room.roomId]);
  }

  toggleNavbar() {
    this.isNavBarOpen = (this.isNavBarOpen == true) ? false : true;
    // return false;
  }

  onOpenLink(roomId: number = null) {
    if (this.isMobileView) {
      setTimeout(() => {
        this.isNavBarOpen = true;
      }, 100);
    }
  }

  onVerifyEmail() {
    this.showSpinner = true;
    this.userClient.generateEmailVerificationLink(this.userDetails.emailId).subscribe(res => {
      if (res === true) {
        this.commonServices.showMessage('X', `Verification link sent on emailId '${this.userDetails.emailId}', 
        Please check spam mails also for verification mail. Link is valid for 60 minutes only. Please re-login after verifying from your email link.`, 20);
      }
      if (res === false) {
        this.commonServices.showMessage('X', `Email already verified, please re-login.`);
      }
      this.showSpinner = false;
    }, error => {
      this.commonServices.showMessage('X', `${error}`, 3);
      this.showSpinner = false;
    });
  }


  onMenuClick() {
    if (this.isMobileView) {
      this.isNavBarOpen = !this.isNavBarOpen;
    }
  }
}
